import EmcService from "@/service/emc-service";

export const emcService = new EmcService();
